<template>
  <li class="last-added-post" v-if="!!post">
    <div class="news-post__wrap">
      <router-link :to="post.link" class="news-post__image">
        <img :src="post.image" />
      </router-link>
      <div class="news-post__content">
        <router-link
          :to="post.link"
          class="news-post__title"
          v-text="post.title"
        />
        <div class="news-post__links">
          <router-link
            :to="post.categoryUrl"
            class="news-post__category"
            v-text="post.categoryTitle"
          />
          <a 
            v-if="post.modelLink && post.model"
            :href="post.modelLink" 
            target="_blank" 
            rel="noopener noreferrer" 
            class="news-post__category"
            v-text="post.model"
          />
          <span class="news-post__date" v-text="post.date" />
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import { mapState } from "vuex";
import convertDate from "@/helpers/convertDate";

// Routes Names
import {blog} from '@/staticData/routesName/blog'
import getBlogImg from "@/helpers/getBlogImg";
export default {
  props: {
    posts: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState("blog", {
      categories: state => state.category
    }),
    post() {
      const testDriveCategory = this.categories[this.categories.length - 1];
      const testDrivePosts = this.posts.filter(
        post => post.category_id === testDriveCategory.id
      );

      const post = testDrivePosts[testDrivePosts.length - 1]

      if (!post) return;

      const categoryUrl   = `${blog}/${testDriveCategory && testDriveCategory.url}`;
      let model           = ''

      if(post.car) {
        const modelBrand = post.car.brand + " ";
        const modelClass = post.car.model_class + " ";
        const modelName = post.car.model_name;
        model = modelBrand + modelClass + modelName;
      }

      return {
        id: post.id,
        title: post && post.title,
        image: getBlogImg(post && post.img && post.img.file_name),
        categoryTitle: testDriveCategory && testDriveCategory.title,
        categoryUrl,
        date: convertDate(post.created),
        link: `${categoryUrl}/${post.id}`,
        model,
        modelLink: post.car && post.car.model_page || ''
      };
    }
  }
};
</script>